import * as React from 'react';

/**
 * React context to store the width expanded state of the side-panel.
 */
export const SidePanelExpandableContext = React.createContext<{
    isExpanded: boolean;
    setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}>({
    isExpanded: false,
    setExpanded: () => {},
});
